import React, { useState } from 'react';
import Modal from '../../../Components/Organisms/Modal';
import RiArrowDropDownLine from '@meronex/icons/ri/RiArrowDropDownLine';
import moment from 'moment';

const OrderTrackingSteps = [
    'Processing',
    'Order Placed',
    'Shipped',
    'Delivered'
];

const statusMapping = {
    CANCELLED: 'Cancelled',
    CREATED: 'Order Placed',
    DISPATCHED: 'Shipped',
    DELIVERED: 'Delivered',
    PROCESSING: 'Processing'
};

const OrderCard = ({ order, isExpanded, toggleExpanded }) => {
    const currentStatus =
        statusMapping[
            order.rewardRedemptionStatus === 'CREATED'
                ? order.payment?.paymentStatus !== 'SUCCESS'
                    ? 'PROCESSING'
                    : 'CREATED'
                : order.rewardRedemptionStatus
        ];
    const currentStatusIndex = OrderTrackingSteps.indexOf(currentStatus);
    const formattedDate = moment(order.createdOn).format('DD MMM YYYY');

    return (
        <div
            className={`w-full lg:w-[95%] xl:w-[75%] flex flex-col bg-white border px-5  lg:px-2 xl:px-5 pt-5 border-gray-300 rounded-lg mb-5`}
        >
            <div className="flex flex-col lg:flex-row">
                <div className="flex-shrink-0">
                    <img
                        className="h-36 w-52 rounded-lg"
                        src={order?.dealDisplayImageUrl}
                        alt=""
                    />
                </div>
                <div className="flex flex-col lg:px-4 lg:py-0 py-3 flex-grow">
                    <div>
                        <div className="flex items-center justify-between lg:mt-1">
                            <div>
                                <h4 className="text-lg font-bold">
                                    {order.dealTitle}
                                </h4>
                            </div>
                        </div>
                    </div>

                    <div className="flex lg:mt-2">
                        <p className="text-base font-semibold text-black">
                            Amount Paid: ₹99{' '}
                            <span className="text-gray-500">
                                {' '}
                                (MRP: {order.dealProductMrp})
                            </span>{' '}
                        </p>
                    </div>
                    <div className="overflow-x-auto scrollbar-thin py-3 lg:py-0">
                        <div className="flex justify-start gap-6 mt-2 lg:mt-3 ">
                            {order.rewardRedemptionStatus === 'CANCELLED' ? (
                                <div className="flex items-center">
                                    <div className="italic text-sm text-red-600 font-semibold">
                                        <p>Cancelled</p>
                                    </div>
                                </div>
                            ) : (
                                OrderTrackingSteps.map((step, index) => (
                                    <div
                                        key={index}
                                        className="flex items-center"
                                    >
                                        <div
                                            className={`italic text-sm whitespace-nowrap ${
                                                currentStatusIndex >= index
                                                    ? 'text-primary font-semibold'
                                                    : 'text-gray-500'
                                            }`}
                                        >
                                            <p>{step}</p>
                                        </div>

                                        {index <
                                            OrderTrackingSteps.length - 1 && (
                                            <hr
                                                className={`h-[2px] w-2 lg:w-2 xl:w-5 rounded ml-5 ${
                                                    currentStatusIndex > index
                                                        ? 'bg-primary'
                                                        : 'bg-[#B7B4CE]'
                                                }`}
                                            />
                                        )}
                                    </div>
                                ))
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <div className="bg-gray-100 -mx-5 lg:-mx-2 xl:-mx-5 mt-4 rounded-b-lg p-4">
                <div className="flex items-center justify-between text-sm">
                    <div className="flex items-center gap-12">
                        <div className="flex flex-col">
                            <p className="text-gray-500">Ordered Date</p>
                            <p className="font-bold mt-1">{formattedDate}</p>
                        </div>
                        <div
                            className="flex items-center cursor-pointer"
                            onClick={toggleExpanded}
                        >
                            <div className="flex flex-col mt-2">
                                <p className="text-gray-500">Ship to</p>
                                <p className="font-bold flex items-center gap-1">
                                    {order.deliveryDetails.customerName
                                        ? order.deliveryDetails.customerName
                                        : order.userName}
                                    <RiArrowDropDownLine
                                        className={`text-gray-500 h-8 w-6 transform ${
                                            isExpanded ? 'rotate-180' : ''
                                        }`}
                                    />
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="flex flex-col mt-2">
                        <p className="text-gray-500">
                            Order :{' '}
                            {order.deliveryDetails.trackingId
                                ? order.deliveryDetails.trackingId
                                : order.id}
                        </p>

                        <p className="font-bold mt-1">
                            {/* {order.deliveryDetails.trackingId || order.id} */}
                        </p>
                    </div>
                </div>

                {isExpanded && (
                    <div className="pl-[131px]">
                        <p className="text-sm text-gray-400">
                            {order.deliveryDetails.shippingAddress.line1 &&
                                `${order.deliveryDetails.shippingAddress.line1}, `}
                            {order.deliveryDetails.shippingAddress.line2 &&
                                `${order.deliveryDetails.shippingAddress.line2}, `}
                            {order.deliveryDetails.shippingAddress.city &&
                                `${order.deliveryDetails.shippingAddress.city}, `}
                            {order.deliveryDetails.shippingAddress.state &&
                                `${order.deliveryDetails.shippingAddress.state}, `}
                            {order.deliveryDetails.shippingAddress.pincode &&
                                `${order.deliveryDetails.shippingAddress.pincode}, `}
                            {order.deliveryDetails.shippingAddress.country}
                        </p>
                        <p className="text-sm text-gray-400">
                            Mobile :{' '}
                            <span className="font-semibold text-black text-sm">
                                {order.deliveryDetails.mobileNumber}
                            </span>
                        </p>
                    </div>
                )}
            </div>
        </div>
    );
};
export default OrderCard;
